export var SICLOrganizationType;
(function (SICLOrganizationType) {
  SICLOrganizationType["ROOT"] = "ROOT";
  SICLOrganizationType["SPORTS_FEDERATION"] = "SPORTS_FEDERATION";
  SICLOrganizationType["AREA"] = "AREA";
  SICLOrganizationType["CLUB"] = "CLUB";
  SICLOrganizationType["CLUB_GROUP"] = "CLUB_GROUP";
  SICLOrganizationType["MINISTRY"] = "MINISTRY";
  SICLOrganizationType["GRANT_STATEMENT_GROUP"] = "GRANT_STATEMENT_GROUP";
  SICLOrganizationType["SPORT_EVENT_SPONSORING_PROJECT"] = "SPORT_EVENT_SPONSORING_PROJECT";
  SICLOrganizationType["MUNICIPALITY"] = "MUNICIPALITY";
  SICLOrganizationType["ASSOCIATION"] = "ASSOCIATION";
  SICLOrganizationType["ORGANIZATION_COLLECTION:MASTER_CLUB"] = "ORGANIZATION_COLLECTION:MASTER_CLUB";
  SICLOrganizationType["ORGANIZATION_COLLECTION:AREA_ASSOCIATION"] = "ORGANIZATION_COLLECTION:AREA_ASSOCIATION";
})(SICLOrganizationType || (SICLOrganizationType = {}));
export var SICLOrganizationUserPermission;
(function (SICLOrganizationUserPermission) {
  SICLOrganizationUserPermission["READ_BASIC_DATA"] = "READ_BASIC_DATA";
  SICLOrganizationUserPermission["UPDATE_ORGANIZATION_DATA"] = "UPDATE_ORGANIZATION_DATA";
  SICLOrganizationUserPermission["MANAGE_USERS"] = "MANAGE_USERS";
  SICLOrganizationUserPermission["ACCESS_ATHLETE_DATA"] = "ACCESS_ATHLETE_DATA";
  SICLOrganizationUserPermission["PURCHASE_ON_BEHALF"] = "PURCHASE_ON_BEHALF";
  SICLOrganizationUserPermission["MANAGE_EVENTS"] = "MANAGE_EVENTS";
  SICLOrganizationUserPermission["APPLY_FOR_GRANTS"] = "APPLY_FOR_GRANTS";
  SICLOrganizationUserPermission["MANAGE_TAHTISEURA"] = "MANAGE_TAHTISEURA";
  SICLOrganizationUserPermission["GRANT_GRANTS"] = "GRANT_GRANTS";
  SICLOrganizationUserPermission["REVIEW_GRANT_APPLICATIONS"] = "REVIEW_GRANT_APPLICATIONS";
  SICLOrganizationUserPermission["HANDLE_ORGANIZATION_CREATE_REQUESTS"] = "HANDLE_ORGANIZATION_CREATE_REQUESTS";
  SICLOrganizationUserPermission["HANDLE_ORGANIZATION_USER_JOIN_REQUESTS"] = "HANDLE_ORGANIZATION_USER_JOIN_REQUESTS";
})(SICLOrganizationUserPermission || (SICLOrganizationUserPermission = {}));
export var SICLSystemUserRole;
(function (SICLSystemUserRole) {
  SICLSystemUserRole["ROLE_USER"] = "ROLE_USER";
  SICLSystemUserRole["ROLE_ORGANIZATION_USER"] = "ROLE_ORGANIZATION_USER";
  SICLSystemUserRole["ROLE_INSURANCE_USER"] = "ROLE_INSURANCE_USER";
  SICLSystemUserRole["ROLE_ADMIN"] = "ROLE_ADMIN";
  SICLSystemUserRole["ROLE_USER_LOCKED"] = "ROLE_USER_LOCKED";
})(SICLSystemUserRole || (SICLSystemUserRole = {}));
export var SICLCrowdType;
(function (SICLCrowdType) {
  SICLCrowdType["Group"] = "Group";
  SICLCrowdType["MembershipClass"] = "MembershipClass";
})(SICLCrowdType || (SICLCrowdType = {}));
export var SICLLocale;
(function (SICLLocale) {
  SICLLocale["fi_FI"] = "fi_FI";
  SICLLocale["sv_SE"] = "sv_SE";
  SICLLocale["en_GB"] = "en_GB";
})(SICLLocale || (SICLLocale = {}));